import { observer } from 'mobx-react';
import * as React from 'react';
import FlashMessage from '../../components/FlashMessage';
import NotificationsStore from '../Store';

interface Props {
  store: NotificationsStore;
}

const NotificationsList: React.FC<Props> = ({ store }) => (
  <>
    {store.notifications.map((flash) => (
      <FlashMessage key={flash.uuid} alert={flash} />
    ))}
  </>
);

export default observer(NotificationsList);
